/**
 * Mobile menu
 */
const componentMobileMenu = (args) => {

  // setup args
  let menu     = args.menu;
  let site     = args.site;
  let toggles  = args.toggles;

  // validate
  if (!menu || !site || !toggles.length) {
    console.log('Invalid mobile_menu args');
    return;
  }

  // setup a11y dialog
  const dialog = new A11yDialog(menu, site);

  // tasks to open menu visually
  const openMenu = () => {
   document.body.classList.add('is-active-menu');
  };

  // tasks to close menu visually
  const closeMenu = () => {

    document.body.classList.add('is-closing-menu');
    setTimeout(() => {
      document.body.classList.remove('is-active-menu');
      document.body.classList.remove('is-closing-menu');
     }, 200);

  };

  // hooks
  dialog.on('show', (element, event) => {
    openMenu();
  });
  dialog.on('hide', (element, event) => {
    closeMenu();
  });

  // toggle click
  const handleToggle = (e) => {
    if (document.body.classList.contains('is-active-menu')) {
       dialog.hide();
    } else {
      dialog.show();
    }
  };

  // close on anchor link
  const anchorLinks = menu.querySelectorAll('a[href*="#"]');
  for (let i = 0; i < anchorLinks.length; i++) {
    if (anchorLinks[i].getAttribute('href') !== '#') {
      anchorLinks[i].addEventListener('click', (e) => {
        dialog.hide();
      });
    }
  }

  for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handleToggle, false);
  }

  // make the call chainable
  return this;

};

/**
 * Init mobile menu
 */
componentMobileMenu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});


/**
 * Fixed header
 */

window.onscroll = function() {fixedHeader()};

// Get the header
var header = document.getElementById("masthead");
var filtersMobile = document.getElementById("filters-mobile");
let headerHeight = 0;
let filtersMobileHeight = 0;
let filtersContainerPosition = 0;



var lastScroll = 0;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function fixedHeader() {
  let currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value


  headerHeight = header.offsetHeight;

  if(filtersMobile) {
    filtersMobileHeight = filtersMobile.offsetHeight;
  }
  if(filtersMobile) {
    filtersContainerPosition = headerHeight + filtersMobileHeight;
  }

  // Direction down
  if (currentScroll > 0 && lastScroll <= currentScroll){
    lastScroll = currentScroll;

    if (window.pageYOffset > 140) {
      header.classList.add("site-header--fixed");

      if(filtersMobile) {
        filtersMobile.classList.add("filters-mobile--fixed");

        document.getElementById("filters-mobile").style.top = 0;

        if (header.classList.contains('site-header--fixed')) {
          document.getElementById("x-filters").style.top = filtersMobileHeight+"px";
        }
        // else {
        //   console.log("1231623532562316531651325631");
        //   document.getElementById("x-filters").style.top = filtersContainerPosition+"px";
        // }
      }
    } else {
      header.classList.remove("site-header--fixed");

      if(filtersMobile) {
        filtersMobile.classList.remove("filters-mobile--fixed");

      }
    }
    // header.classList.remove("site-header--fixed-small");

  }

  // Direction up
  else{
    lastScroll = currentScroll;
    header.classList.remove("site-header--fixed");

    if(filtersMobile) {
      filtersMobile.classList.remove("filters-mobile--fixed");
      document.getElementById("filters-mobile").style.top = headerHeight+"px";

      if (header.classList.contains('site-header--fixed')) {
        document.getElementById("x-filters").style.top = filtersMobileHeight+"px";
      }
      else {
        document.getElementById("x-filters").style.top = filtersContainerPosition+"px";
      }
    }

    // header.classList.add("site-header--fixed-small");

    // if (window.pageYOffset < 140) {
    //   header.classList.remove("site-header--fixed-small");
    // }
  }
}


window.addEventListener("resize", function(event) {
  let header = document.querySelector('#masthead');
  // let width = box.offsetWidth;
  let headerHeight = header.offsetHeight;

  let filtersMobile = document.querySelector('#filters-mobile');

  if(filtersMobile) {
    let filtersMobileHeight = filtersMobile.offsetHeight;
    let filtersContainerPosition = headerHeight + filtersMobileHeight


    document.getElementById("filters-mobile").style.top = headerHeight+"px";
    document.getElementById("x-filters").style.top = filtersContainerPosition+"px";
  }

});


function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
  } else {
      document.addEventListener("DOMContentLoaded", fn);
  }
}


docReady(function() {
  var filtersMobile = document.getElementById("filters-mobile");

  if(filtersMobile) {
    let header = document.querySelector('#masthead');
    let headerHeight = header.offsetHeight;
    let filtersMobile = document.querySelector('#filters-mobile');
    let filtersMobileHeight = filtersMobile.offsetHeight;
    let filtersContainerPosition = headerHeight + filtersMobileHeight

    document.getElementById("filters-mobile").style.top = headerHeight+"px";
    document.getElementById("x-filters").style.top = filtersContainerPosition+"px";
  }

});
